/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedataresettoai4Inputs */

const en_casedataresettoai4 = /** @type {(inputs: Casedataresettoai4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let AI manage this`)
};

const pt_casedataresettoai4 = /** @type {(inputs: Casedataresettoai4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar a IA gerir`)
};

/**
* | output |
* | --- |
* | "Let AI manage this" |
*
* @param {Casedataresettoai4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedataresettoai4 = /** @type {((inputs?: Casedataresettoai4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedataresettoai4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedataresettoai4(inputs)
	return pt_casedataresettoai4(inputs)
});
export { casedataresettoai4 as "caseDataResetToAi" }